'use strict';
module.exports = (flag, argv) => {
	argv = argv || process.argv;
	const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
	const pos = argv.indexOf(prefix + flag);
	const terminatorPos = argv.indexOf('--');
	return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};



//////////////////
// WEBPACK FOOTER
// ./~/supports-color/~/has-flag/index.js
// module id = 242
// module chunks = 0 1